module.exports = __webpack_public_path__ + "media/images/icon_list/copy-75bb622f289558d9ef27040257c24e46.svg";